import { useState } from 'react';
import { ArrowLeftIcon, FunnelIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import OpportunityList from '../pages/screening/OpportunityList';
import OpportunityDetail from '../pages/screening/OpportunityDetail';

interface ScreeningWorkspaceProps {
  /** 返回模块首页 */
  onBack: () => void;
  /** 退出登录 */
  onLogout: () => void;
  /** 转入投标文件编写模块 */
  onOpenBidWriting: (projectId?: number) => void;
}

/**
 * 招标信息筛选模块工作台
 *
 * 列表页与详情页共用同一外壳，详情页通过 onBack 返回列表。
 */
export default function ScreeningWorkspace({
  onBack,
  onLogout,
  onOpenBidWriting,
}: ScreeningWorkspaceProps) {
  const [detailId, setDetailId] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-10 border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={detailId === null ? onBack : () => setDetailId(null)}
              className="flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-1.5 text-sm text-gray-600 transition hover:bg-gray-50"
            >
              <ArrowLeftIcon className="h-4 w-4" />
              {detailId === null ? '切换模块' : '返回列表'}
            </button>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
                <FunnelIcon className="h-5 w-5" />
              </span>
              <div>
                <h1 className="text-base font-semibold text-gray-900">招标信息筛选</h1>
                <p className="text-xs text-gray-500">
                  录入招标信息 → 对照公司资质 → 判断这个标值不值得投
                </p>
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={onLogout}
            className="flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-1.5 text-sm text-gray-600 transition hover:bg-gray-50"
          >
            <ArrowRightOnRectangleIcon className="h-4 w-4" />
            退出登录
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-6">
        {detailId === null ? (
          <OpportunityList onOpenDetail={setDetailId} />
        ) : (
          <OpportunityDetail
            opportunityId={detailId}
            onBack={() => setDetailId(null)}
            onOpenBidWriting={onOpenBidWriting}
          />
        )}
      </main>
    </div>
  );
}
